import { EventFilterType, EventType } from 'types/memberDetails';

export const PastEventFilter: EventType = 'past';
export const UpcomingEventFilter: EventType = 'upcoming';

export const eventTypesFilters: EventFilterType[] = [
  { value: UpcomingEventFilter, label: 'Upcoming Events' },
  { value: PastEventFilter, label: 'Past Events' },
];
